import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Injectable({
  providedIn: 'root'
})
export class ModalService {

  constructor(private readonly modalService: NgbModal) {
    window.onpopstate = () => {
      this.closeModals();
    };
  }

  closeModals() {
    this.modalService.dismissAll();
  }
}
